var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-view step-8"},[_c('div',{staticClass:"congrats-wrapper"},[_c('div',{staticClass:"inner"},[_vm._m(0),_c('div',{staticClass:"content"},[_c('ScrumVision'),_c('h3',[_vm._v("恭喜通過 Scrum 新手村")]),_c('p',[_vm._v("正式加入敏捷資訊的開發 A 組")])],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rating"},[_c('img',{attrs:{"src":require("@/assets/images/star.png"),"alt":"star"}})])
}]

export { render, staticRenderFns }